var _rect, _g, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_413_328)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3325 15.9999C25.3324 16.3876 25.2197 16.767 25.008 17.0919C24.7962 17.4167 24.4946 17.673 24.1399 17.8295C23.7851 17.9861 23.3925 18.0361 23.0098 17.9736C22.6271 17.911 22.2709 17.7386 21.9845 17.4772L18.6445 19.7039C18.6565 19.7886 18.6638 19.8739 18.6651 19.9606L21.8918 21.9459C22.2188 21.6065 22.6552 21.3936 23.1239 21.3446C23.5927 21.2956 24.0636 21.4137 24.4538 21.6781C24.8439 21.9425 25.1282 22.3362 25.2564 22.7897C25.3846 23.2432 25.3486 23.7274 25.1546 24.1569C24.9606 24.5864 24.6212 24.9336 24.1962 25.1373C23.7712 25.341 23.288 25.3881 22.8317 25.2702C22.3754 25.1524 21.9753 24.8772 21.7021 24.4931C21.429 24.1091 21.3001 23.6409 21.3385 23.1712L18.2238 21.2539C17.9724 21.5661 17.633 21.7955 17.2497 21.9125C16.8663 22.0295 16.4567 22.0285 16.0738 21.9099C15.691 21.7912 15.3527 21.5602 15.1027 21.2469C14.8527 20.9336 14.7026 20.5525 14.6719 20.1528C14.6412 19.7532 14.7312 19.3536 14.9304 19.0057C15.1296 18.6579 15.4286 18.378 15.7888 18.2022C16.149 18.0264 16.5537 17.9629 16.9505 18.0199C17.3472 18.0769 17.7177 18.2518 18.0138 18.5219L21.3538 16.2952C21.3138 16.0234 21.3302 15.7462 21.402 15.481C21.4739 15.2157 21.5996 14.9682 21.7714 14.7537C21.9431 14.5392 22.1573 14.3624 22.4004 14.2344C22.6435 14.1063 22.9104 14.0297 23.1844 14.0094C23.4584 13.9891 23.7337 14.0254 23.9931 14.1162C24.2524 14.2069 24.4903 14.3501 24.6918 14.5369C24.8934 14.7237 25.0543 14.95 25.1645 15.2017C25.2747 15.4534 25.3319 15.7251 25.3325 15.9999Z",
    fill: "#333334"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "black",
    strokeOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_413_328"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButton);
export default __webpack_public_path__ + "static/media/Button.f79162d88a0fb2f95cc2277f1baa0458.svg";
export { ForwardRef as ReactComponent };